import { getAllContextValues } from "../secret_internals.js";
export let realTimeDataInspectRoot;
export const RealTimeDataInspectHooks = [];
export function setRealTimeDataInspectRoot(root) {
  realTimeDataInspectRoot = root;
  const data = getAllContextValues({
    tplStateStoreId: root.tplStateStoreId
  });
  callRealTimeDataInspectHooks({
    changeType: "initialize",
    tplStateStoreId: root.tplStateStoreId,
    detail: {
      data
    }
  });
}
export function addRealTimeDataInspectHook(hook) {
  RealTimeDataInspectHooks.push(hook);
}
export function callRealTimeDataInspectHooks(detail) {
  setTimeout(() => {
    for (const hook of RealTimeDataInspectHooks) {
      try {
        hook(detail);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`RealTimeDataInspectHook failed (${detail.changeType}):`, error);
      }
    }
  });
}
//# sourceMappingURL=realTimeDataInspect.js.map